import { Terceiro } from "./terceiro/entities/Terceiro";
import axios from "axios";

const endereco = axios.create({
  baseURL: "https://viacep.com.br/ws/",
  headers: {
    Accept: "application/json",
    "Content-Type": "applicattion/json;",
  },
});

const actions = {
  criarParceiro: async (
    context,
    {
      cnpj,
      nome,
      unidadeId,
      razaoSocial,
      inscricaoEstadual,
      bairro,
      rua,
      numero,
      cidade,
      estado,
      cep,
    }
  ) => {
    const api = context.rootState.autenticacao.api;

    await api.post(`/ter/unidade/${unidadeId}/parceiro`, {
      nome: nome,
      cnpj: cnpj,
      razaoSocial,
      inscricaoEstadual,
      rua,
      numero,
      cidade,
      estado,
      cep,
      bairro,
    });
  },

  editarParceiro: async (
    context,
    {
      parceiroId,
      cnpj,
      nome,
      unidadeId,
      razaoSocial,
      inscricaoEstadual,
      rua,
      numero,
      cidade,
      estado,
      cep,
    }
  ) => {
    const api = context.rootState.autenticacao.api;

    await api.put(`/ter/unidade/${unidadeId}/parceiro/${parceiroId}`, {
      nome,
      cnpj,
      razaoSocial,
      inscricaoEstadual,
      rua,
      numero,
      cidade,
      estado,
      cep,
    });
  },

  listarParceiros: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.get(`/ter/unidade/parceiro`, {
      params: {
        unidadeId,
      },
    });

    return {
      response,
    };
  },

  criarTerceiro: async (
    context,
    { nome, matricula, areaId, parceiroId, email, celular, unidadeId }
  ) => {
    const api = context.rootState.autenticacao.api;
    await api.post(
      `/ter/unidade/${unidadeId}/parceiro/${parceiroId}/terceiro`,
      {
        nome: nome,
        matricula: matricula,
        areaId: areaId,
        parceiroId: parceiroId,
        email: email,
        celular: celular,
      }
    );
  },

  editarTerceiro: async (
    context,
    {
      nome,
      matricula,
      areaId,
      parceiroId,
      email,
      celular,
      unidadeId,
      terceiroId,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    await api.put(
      `/ter/unidade/${unidadeId}/parceiro/${parceiroId}/terceiro/${terceiroId}`,
      {
        nome: nome,
        matricula: matricula,
        areaId: areaId,
        parceiroId: parceiroId,
        email: email,
        celular: celular,
      }
    );
  },

  listarTerceiros: async (context, { parceiroId, unidadeId }) => {
    const api = context.rootState.autenticacao.api;

    let resposta = await api.get(
      `/ter/unidade/${unidadeId}/parceiro/${parceiroId}/terceiro`
    );

    resposta = resposta.data;

    let listaterceiros = [];
    resposta.resultado.dados.forEach((terceiroDTO) => {
      listaterceiros.push(
        new Terceiro({
          terceiroId: terceiroDTO.terceiroId,
          parceiroId: terceiroDTO.parceiroId,
          nome: terceiroDTO.nome,
          matricula: terceiroDTO.matricula,
          areaId: terceiroDTO.areaId,
          ativo: terceiroDTO.ativo,
        })
      );
    });

    return {
      listaterceiros,
    };
  },

  removerParceiro: async (context, { parceiroId, unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.delete(
      `/ter/unidade/${unidadeId}/parceiro/${parceiroId}`
    );
    return resposta;
  },

  removerTerceiro: async (context, { parceiroId, terceiroId, unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.delete(
      `/ter/unidade/${unidadeId}/parceiro/${parceiroId}/terceiro/${terceiroId}`
    );
    return resposta;
  },

  verificarCep: async (context, { cep }) => {
    const response = await endereco.get(`${cep}/json`);

    return response;
  },
};

export const ter = {
  namespaced: true,
  actions,
};
